import { Briefcase } from "lucide-react";
import { useLang } from "@/i18n";

export default function Careers() {
  const { lang } = useLang();
  const t = (tr, en) => (lang === "tr" ? tr : en);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="careers-page">
      <div className="flex items-center gap-3 mb-6">
        <Briefcase className="text-red-500" size={28} />
        <span className="eyebrow text-red-500">KARİYER · Loft Press Ltd</span>
      </div>
      <h1 className="headline text-5xl sm:text-6xl text-white">
        {t("Kariyer", "Careers")}
      </h1>
      <p className="mt-8 text-lg text-neutral-300 leading-relaxed max-w-2xl">
        {t(
          "Şu anda açık pozisyon bulunmamaktadır. Gelecekteki fırsatlar bu sayfada yayınlanacaktır.",
          "There are currently no open positions. Future opportunities will be posted on this page."
        )}
      </p>
    </div>
  );
}
